import React from 'react';

interface Chip {
  key: string;
  label: string;
}

interface ActiveFilterChipsProps {
  chips: Chip[];
  onRemove: (key: string) => void;
  onClearAll?: () => void;
}

export function ActiveFilterChips({ chips, onRemove, onClearAll }: ActiveFilterChipsProps) {
  if (!chips.length) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 mt-3">
      {chips.map((chip) => (
        <span key={chip.key} className="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-white px-2.5 py-1 text-xs text-gray-700">
          {chip.label}
          <button aria-label={`Remove ${chip.label}`} onClick={() => onRemove(chip.key)} className="ml-1 rounded-full p-0.5 hover:bg-gray-100">
            ×
          </button>
        </span>
      ))}
      {onClearAll && (
        <button onClick={onClearAll} className="text-xs text-gray-600 hover:text-gray-800 ml-1">Clear filters</button>
      )}
    </div>
  );
}


